module.exports = __webpack_public_path__ + "static/media/delivery-black.51ac397c.svg";